import './App.css';
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';
import Menu from './pages/Menu';
import Info from './pages/Info';

import VanishedFantasy from './works/VanishedFantasy';
import SpaceOut from './works/SpaceOut';
import ProtoCarbon from './works/ProtoCarbon';

import CollectorsWords from './commissions/CollectorsWords';
import Seoul2121 from './commissions/Seoul2121';

function App() {
  return (
    <div>
      <BrowserView>
        <div className="App">
          <Router>
            <Menu />
            <Routes>
              <Route path="/" exact element={<ProtoCarbon />} />
              <Route path="/spaceout" exact element={<SpaceOut />} />
              <Route path="/vanishedfantasy" exact element={<VanishedFantasy />} />

              <Route path="/seoul2121" exact element={<Seoul2121 />} />
              <Route path="/collectorswords" exact element={<CollectorsWords />} />

              <Route path="/info" exact element={<Info />} />
            </Routes>
          </Router>
        </div>
      </BrowserView>
      <MobileView>
        <ProtoCarbon />
        <SpaceOut />
        <VanishedFantasy />
        <Seoul2121 />
        <CollectorsWords />
        <Info />
      </MobileView>
    </div>
  );
}

export default App;
